import React from "react";

// set the defaults theme
const ThemeContext = React.createContext({
  theme: "light",
  setTheme: () => {},
});

export default ThemeContext;
